// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

//ENUMS
// eslint-disable-next-line no-unused-vars
import { ProjectSort } from "@/enums/Project/ProjectSort.js";

// ## Project Get
/**
 *
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.CycleParameters.GetAll(option));

  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Project Create
/**
 *
 * @param {[{"key": "string","value": 0}]} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.CycleParameters.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
};
